var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{attrs:{"url":"/renovacoes/config/valor/licencas/create","valor":{}}})
}
var staticRenderFns = []

export { render, staticRenderFns }